/* RESPONSIBLE TEAM: team-ai-agent */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';

export default class AppsAppOperatorResolutionBotBehaviorsIndexRoute extends IntercomRoute {
  @service router;

  redirect() {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.profiles');
  }
}
